import Cookies from 'js-cookie';

const state = {
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : false,
      withoutAnimation: true,
      // 当前选中的页面在导航的位置
      currNavIndex:0
    },
    token:""
};

const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened;
        state.sidebar.withoutAnimation = false;

        if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1);
        } else {
            Cookies.set('sidebarStatus', 0);
        }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0);
        state.sidebar.opened = false;
        state.sidebar.withoutAnimation = withoutAnimation;
    },
    CHANGE_NAV_INDEX:(state,index)=>{
        state.sidebar.currNavIndex = index;
    }
};

const actions = {
    toggleSideBar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    closeSideBar({ commit }, { withoutAnimation }) {
        commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    changeNavIndex({ commit }, index){
        commit('CHANGE_NAV_INDEX', index);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}